import { createApp } from 'vue'
import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './styles/global.css'
import { createI18n } from 'vue-i18n'
import { installApiAdapter } from './utils/apiAdapter'

// 注册全局 axios 响应适配器：把 globalshop API 的 snake_case 字段
// 映射为 camelCase 并展平分页结构，使前端组件能直接用 categoryId/sortOrder 等
installApiAdapter(axios)

// Import all 48 language files
import en from './locales/en.json'
import zh from './locales/zh.json'
import ja from './locales/ja.json'
import ko from './locales/ko.json'
import fr from './locales/fr.json'
import de from './locales/de.json'
import es from './locales/es.json'
import it from './locales/it.json'
import pt from './locales/pt.json'
import ru from './locales/ru.json'
import ar from './locales/ar.json'
import hi from './locales/hi.json'
import th from './locales/th.json'
import vi from './locales/vi.json'
import id from './locales/id.json'
import ms from './locales/ms.json'
import tl from './locales/tl.json'
import tr from './locales/tr.json'
import pl from './locales/pl.json'
import nl from './locales/nl.json'
import sv from './locales/sv.json'
import da from './locales/da.json'
import fi from './locales/fi.json'
import no from './locales/no.json'
import cs from './locales/cs.json'
import hu from './locales/hu.json'
import ro from './locales/ro.json'
import el from './locales/el.json'
import he from './locales/he.json'
import uk from './locales/uk.json'
import bg from './locales/bg.json'
import hr from './locales/hr.json'
import sk from './locales/sk.json'
import sl from './locales/sl.json'
import lt from './locales/lt.json'
import lv from './locales/lv.json'
import et from './locales/et.json'
import sr from './locales/sr.json'
import ca from './locales/ca.json'
import fa from './locales/fa.json'
import bn from './locales/bn.json'
import ta from './locales/ta.json'
import ur from './locales/ur.json'
import sw from './locales/sw.json'
import af from './locales/af.json'
import sq from './locales/sq.json'
import be from './locales/be.json'
import zhTW from './locales/zh-TW.json'

const messages = {
  en, zh, ja, ko, fr, de, es, it, pt, ru,
  ar, hi, th, vi, id, ms, tl, tr, pl, nl,
  sv, da, fi, no, cs, hu, ro, el, he, uk,
  bg, hr, sk, sl, lt, lv, et, sr, ca, fa,
  bn, ta, ur, sw, af, sq, be, 'zh-TW': zhTW
}

const i18n = createI18n({
  legacy: false,
  locale: localStorage.getItem('locale') || 'en',
  fallbackLocale: 'en',
  messages
})

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.use(i18n)

app.mount('#app')
